<div class="ad-container" [style.background-image]="'url(' + adconfig.url + ')'" [ngClass]="{'h-100': largerHeight}">
  <a class="ads-link primary-ads-link align-items-center d-flex position-relative padding-for-16-9" [href]="adconfig.clickthroughLink"
    target="_blank" rel="noopener noreferrer" [ngClass]="{'h-100': largerHeight}">
    <img class="position-absolute ad-img" [src]="adconfig.url" alt="{{ 'GENERIC.COMMON_PAGES.AD_BANNER_IMAGE_ALTERNATE_TEXT' | translate }}">
  </a>
</div>
